export default __webpack_public_path__ + "static/media/bg-3of7.b77abe0b.svg";